import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isDirty as isDirtyMetrics } from '../metrics/selectors';
import { isDirty as isDirtyRangeFilter } from '../../../common/RangeFilter/selectors';

const DirtyFilterOverlay = ({ isChanged, style }) => (
  <div
    display-if={isChanged}
    className="c-report-dirty-filter"
    style={style}
    data-automation-id="overlay:dirtyFilter"
  />
);

DirtyFilterOverlay.propTypes = {
  isChanged: PropTypes.bool.isRequired,
  style: PropTypes.object, // eslint-disable-line
};

DirtyFilterOverlay.defaultProps = {
  style: {},
};

export default connect(
  state => ({
    isChanged: isDirtyMetrics(state) || isDirtyRangeFilter(state),
  })
)(DirtyFilterOverlay);
